import dayjs from "dayjs";

export const PERMISO_EXPECTED_CP = "Permisos_Expected_CP";

export function toExpectedDateKey(value) {
  if (value == null || value === "" || value === "—" || value === "— —") {
    return null;
  }
  const d = dayjs(value);
  return d.isValid() ? d.format("YYYY-MM-DD") : null;
}

/** null = clear; string = YYYY-MM-DD; undefined = fecha inválida (ignorar). */
export function normalizePickerDate(value) {
  if (value === null || value === undefined || value === "") return null;
  const d = dayjs(value);
  if (!d.isValid()) return undefined;
  return d.format("YYYY-MM-DD");
}

export function isSameDateKey(a, b) {
  return toExpectedDateKey(a) === toExpectedDateKey(b);
}

export function hasLockedExpectedDate(currentExpected) {
  return Boolean(toExpectedDateKey(currentExpected));
}

export function canEditExpectedDate(
  hasPermission,
  currentExpected,
  { sessionUnlocked = false } = {},
) {
  return (
    Boolean(hasPermission) ||
    sessionUnlocked ||
    !hasLockedExpectedDate(currentExpected)
  );
}

export function collectSessionUnlockedExpectedIds(timeline = []) {
  return new Set(
    (Array.isArray(timeline) ? timeline : [])
      .filter((t) => t?.Id != null && !hasLockedExpectedDate(t.ExpectedDate))
      .map((t) => t.Id),
  );
}

export function pendingExpectedForTask(pendingById = {}, taskId) {
  if (Object.prototype.hasOwnProperty.call(pendingById, taskId)) {
    return pendingById[taskId];
  }
  const asString = String(taskId);
  if (Object.prototype.hasOwnProperty.call(pendingById, asString)) {
    return pendingById[asString];
  }
  return undefined;
}

export function mergePendingExpectedDates(timeline = [], pendingById = {}) {
  const rows = Array.isArray(timeline) ? timeline : [];
  if (!pendingById || Object.keys(pendingById).length === 0) return rows;
  return rows.map((t) => {
    const pending = pendingExpectedForTask(pendingById, t?.Id);
    return pending === undefined ? t : { ...t, ExpectedDate: pending };
  });
}

export function hasPendingExpectedToLock(pendingById = {}) {
  return Object.values(pendingById || {}).some((value) =>
    hasLockedExpectedDate(value),
  );
}
